import {
	ClaimSolutionEnum,
	ClaimStatusEnum,
	ClaimTypeEnum,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const getOrderUpdateClaimSchema = () => {
	return z.object({
		status: z.nativeEnum(ClaimStatusEnum),
		type: z.nativeEnum(ClaimTypeEnum),
		fee: z.number().nullish(),
		description: z.string().nullish(),
		finalSolution: z.nativeEnum(ClaimSolutionEnum).nullish(),
		dateNextAction: z.string().nullish(),
		dateResolved: z.string().nullish(),
		partnerId: z.number(),
	});
};

export type OrderUpdateClaimFormModel = z.infer<
	ReturnType<typeof getOrderUpdateClaimSchema>
>;
